import styled, { css } from 'styled-components';
export const BubbleSelectMultiple = styled.div`
  position: sticky;
  right: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #4c5ecf;
  line-height: 16px;
  font-weight: 700;
  font-size: 11px;
  color: #fff;
  border-radius: 10px;
  padding: 0 5px;

  ${props => props.disabled && css`
      opacity: 0.5;
    `}
`;